import { useState } from "react";
import { BOOK2_URL } from "@/constants/site";

const go = (id) => (e) => {
  e.preventDefault();
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => {
  const [hovered, setHovered] = useState(null);

  const linkCls = (key) =>
    `font-tech text-[11px] uppercase tracking-[0.25em] transition-colors duration-300 ${
      hovered === key ? "text-sky-400" : "text-zinc-400"
    }`;

  const links = [
    { key: "series", id: "#series", label: "Book Two", testid: "nav-link-series" },
    { key: "story", id: "#story", label: "Story", testid: "nav-link-story" },
    { key: "book", id: "#book", label: "The Book", testid: "nav-link-book" },
    { key: "reviews", id: "#reviews", label: "Reviews", testid: "nav-link-reviews" },
  ];

  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-2xl border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={go("#top")}
          className="flex items-baseline gap-2 group"
        >
          <span className="font-display italic text-2xl text-white transition-colors duration-300 group-hover:text-sky-300">
            Aurora
          </span>
          <span className="font-tech text-[10px] uppercase tracking-[0.3em] text-zinc-500">
            Chronicles
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.key}
              href={l.id}
              data-testid={l.testid}
              onClick={go(l.id)}
              className={linkCls(l.key)}
              onMouseEnter={() => setHovered(l.key)}
              onMouseLeave={() => setHovered(null)}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={BOOK2_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-buy-button"
          className="font-tech text-[11px] uppercase tracking-[0.25em] bg-sky-500 text-black px-5 py-2.5 hover:bg-sky-400 hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
        >
          Order — $29.99
        </a>
      </div>
    </header>
  );
};

export default Nav;
